import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import LicensedModule from "../../../../models/LicensedModule";

interface OwnProps {
    module?: LicensedModule;
}

type Props = OwnProps;

const ModuleCardHeader: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = observer((props) => {
    let headerContent: React.ReactNode = null;

    return (
        <>
            {Boolean(headerContent) && (
                <Grid
                    item
                    xs={12}
                    direction={"row"}
                    wrap={"nowrap"}
                    container
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                    sx={{
                        paddingLeft: 3,
                        paddingRight: 3,
                        marginTop: 3,
                        paddingBottom: 2,
                    }}
                >
                    <Grid item xs={4}>
                        {headerContent}
                    </Grid>
                    <Grid
                        item
                        xs={8}
                        container
                        justifyContent={"flex-start"}
                        alignItems={"baseline"}
                        wrap={"wrap"}
                    ></Grid>
                </Grid>
            )}
        </>
    );
});

export default ModuleCardHeader;
